.root {
  border-bottom: 1px solid;
  border-color: var(--tuna-palette-divider);
  margin-bottom: 16px;
}

.container {
  display: flex;
  min-height: 200px;
}

.tabs {
  border-right: 1px solid var(--tuna-palette-divider);
  min-width: 140px;
  flex-direction: column;
}

.content {
  flex: 1;
  padding-left: 24px;
}

.scoreDisplay {
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bonusLabel {
  margin-bottom: 8px;
}

.progressBar {
  height: 10px;
  border-radius: 5px;
}

.bonusCaption {
  margin-top: 4px;
  display: block;
  text-align: right;
}

.tabContent {
  padding-top: 16px;
}
